import Axios from 'axios';
import { getUrlParam } from '@/scripts/utils';

const baseUrl = 'https://us-central1-gucci-20-games.cloudfunctions.net/';
// const userId = getUrlParam('userId');
const userName = getUrlParam('userName');
const userId = getUrlParam('userId') || '3217a383-99c8-4416-a665-cfc51f859d2d';

export default {
  async getUserData({ commit }) {
    await Axios.get(`${baseUrl}game/getUserKenScott/${userId}`).then((response) => {
      commit('SET_USER_DATA', { ...response.data, userName });
    }).catch(() => {
      commit('SET_USER_DATA', {
        score: 0,
        userName: getUrlParam('userName'),
        scoreRange: [],
        data: {
          mt: 0,
          strawberries: 0,
          blueberries: 0,
        },
      });
    });
  },

  async saveUserScore({ dispatch, state }, score) {
    const responseScore = Axios.get(`${baseUrl}game/updateScoreKenScott/${userId}/${score}`);
    const { mt, strawberries, blueberries } = state.userData.data;
    const responseData = Axios.get(`${baseUrl}game/updateDataKenScott/${userId}/${parseInt(mt, 10) + score}/${strawberries}/${blueberries}`);
    try {
      const res = await Promise.all([responseScore, responseData]);
      if (res) await dispatch('getUserData');
    } catch (e) { console.log(e); }
  },
};
